<template>
  <div class="loading-container">
    <div class="loading-info">
      <i class="fa-solid fa-spinner fa-spin-pulse"></i><br />
      <p>{{ message }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    message: {
      type: String,
      default: '読み込み中'
    }
  },
  
});
</script>
<style scoped>
.loading-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ccc;
  height: 100%;
  width: 100%;
  padding: 20px 0;
}
.loading-info {
  text-align: center;
}

/* .loading-info {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  text-align: center;
} */
i {
  font-size: 5rem;
}
p {
  margin-top: 10px;
}
</style>